const locale: Locale = {
  ko: {
    prev: '이전',
    next: '다음',
  },
  en: {
    prev: 'prev',
    next: 'next',
  },
}

export default locale
